import treeHtml from './tree.html';
import MainShapeType from './../contraCp/types/mainShapeType';
import HoleType from './../contraCp/types/holeType';
import printsService from './../configuratorPrints/prints.service';

class treeController {
    constructor($scope, ModalService) {
        'ngInject';

        this.$scope = $scope;
        this.modalService = ModalService;
    }

    add() {
        this.items.push({
            id: Math.floor(new Date().valueOf() * Math.random()),
            name: '',
            mobile_name: '',
            admin_name: '',
            description: '',
            shortcode: '',
            image: null,
            image_description: '',
            items: []
        });
        this.saved = false;
    }

    restore(item) {
        const index = this.items.indexOf(item);

        if (index !== -1) {
            this.items[index].deleted_at = null;
            //this.items.splice(index, 1);
            this.saved = false;
        }
    }

    remove(item) {
        const index = this.items.indexOf(item);

        if (index !== -1) {
            const dateTimeIsoArray = new Date().toISOString().match(/(\d{4}\-\d{2}\-\d{2})T(\d{2}:\d{2}:\d{2})/);
            this.items[index].deleted_at = dateTimeIsoArray[1] + ' ' + dateTimeIsoArray[2];
            //this.items.splice(index, 1);
            this.saved = false;
        }
    }

    fileUpload(item) {
        FMGR_setCallback(imageData => {
            item.image = {
                data: imageData[0],
                src: `/images/show/32/32/?f=${ base64_encode(imageData[0]) }`
            };
            this.$scope.$apply();
        });
        FMGR_BrowseServer('Images', 'xIMAGES', false);
        this.saved = false;
    }

    imageDescription(item) {
        const languages = this.languages;

        this.modalService.showModal({
            template: `<div class="modal material-image-name-modal">
                <div>
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <div ng-repeat="language in $ctrl.languages">
                        <label>Opis ikony materiału w języku <img ng-src="/assets/common/flags/by-locales/{{ language.locale }}.png" alt="{{ language.locale }}" /> {{ language.image_description }}:</label>
                        <br />
                        <input type="text" ng-model="$ctrl.translations[language.locale].image_description" />
                    </div>
                    <br />
                    <br />
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz materiał</span><i class="material-icons">save</i></button>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, languages, translations, close) {
                    'ngInject';

                    this.languages = languages;
                    this.translations = translations;
                    this.closeCallback = close;
                }

                save() {
                    this.closeCallback(this.translations);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                languages: languages,
                translations: item.translations
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                item.translations = result;
                this.saved = false;
            });
        });
    }

    removeFile(item) {
        item.image = null;
        this.saved = false;
    }

    name(item) {
        const languages = this.languages;

        this.modalService.showModal({
            template: `<div class="modal material-name-modal">
                <div>
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <div ng-repeat="language in $ctrl.languages">
                        <label>Nazwa w języku <img ng-src="/assets/common/flags/by-locales/{{ language.locale }}.png" alt="{{ language.locale }}" /> {{ language.name }}:</label>
                        <br />
                        <input type="text" ng-model="$ctrl.translations[language.locale].name" />
                    </div>
                    <br />
                    <br />
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz materiał</span><i class="material-icons">save</i></button>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, languages, translations, close) {
                    'ngInject';

                    this.languages = languages;
                    this.translations = translations;
                    this.closeCallback = close;
                }

                save() {
                    this.closeCallback(this.translations);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                languages: languages,
                translations: item.translations
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                item.translations = result;
                this.saved = false;
            });
        });
    }

    mobileName(item) {
        const languages = this.languages;

        this.modalService.showModal({
            template: `<div class="modal material-mobile-name-modal">
                <div>
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <div ng-repeat="language in $ctrl.languages">
                        <label>Nazwa mobilna w języku <img ng-src="/assets/common/flags/by-locales/{{ language.locale }}.png" alt="{{ language.locale }}" /> {{ language.mobile_name }}:</label>
                        <br />
                        <input type="text" ng-model="$ctrl.translations[language.locale].mobile_name" />
                    </div>
                    <br />
                    <br />
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz materiał</span><i class="material-icons">save</i></button>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, languages, translations, close) {
                    'ngInject';

                    this.languages = languages;
                    this.translations = translations;
                    this.closeCallback = close;
                }

                save() {
                    this.closeCallback(this.translations);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                languages: languages,
                translations: item.translations
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                item.translations = result;
                this.saved = false;
            });
        });
    }

    description(item) {
        const languages = this.languages;

        this.modalService.showModal({
            template: `<div class="modal material-description-modal">
                <div>
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <div class="scrollable">
                        <div ng-repeat="language in $ctrl.languages" class="onecolumn">
                            <div class="header" collapse="collapse-description-{{ language.locale }}">
                                <span>Opis w języku <img ng-src="/assets/common/flags/by-locales/{{ language.locale }}.png" alt="{{ language.locale }}" /> {{ language.name }}</span>
                            </div>
                            <br class="clear">
                            <div class="content">
                                <textarea rows="7" ng-model="$ctrl.translations[language.locale].description"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz materiał</span><i class="material-icons">save</i></button>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, languages, translations, close) {
                    'ngInject';

                    this.languages = languages;
                    this.translations = translations;
                    this.closeCallback = close;
                }

                save() {
                    this.closeCallback(this.translations);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                languages: languages,
                translations: item.translations
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                item.translations = result;
                this.saved = false;
            });
        });
    }

    shortcode(item) {
        const languages = this.languages;

        this.modalService.showModal({
            template: `<div class="modal material-shortcode-modal">
                <div>
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <div ng-repeat="language in $ctrl.languages">
                        <label>Skrót materiału w języku <img ng-src="/assets/common/flags/by-locales/{{ language.locale }}.png" alt="{{ language.locale }}" /> {{ language.name }}:</label>
                        <br />
                        <input type="text" ng-model="$ctrl.translations[language.locale].shortcode" />
                    </div>
                    <br />
                    <br />
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz materiał</span><i class="material-icons">save</i></button>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, languages, translations, close) {
                    'ngInject';

                    this.languages = languages;
                    this.translations = translations;
                    this.closeCallback = close;
                }

                save() {
                    this.closeCallback(this.translations);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                languages: languages,
                translations: item.translations
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                item.translations = result;
                this.saved = false;
            });
        });
    }

    seo(item) {
        const languages = this.languages;

        this.modalService.showModal({
            template: `<div class="modal material-shortcode-modal">
                <div>
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <div class="scrollable">
                        <div ng-repeat="language in $ctrl.languages" class="onecolumn">
                            <div class="header" collapse="collapse-seo-{{ language.locale }}">
                                <span>SEO w języku <img ng-src="/assets/common/flags/by-locales/{{ language.locale }}.png" alt="{{ language.locale }}" /> {{ language.name }} </span>
                            </div>
                            <br class="clear">
                            <div class="content">
                                <label>Tytuł w języku {{ language.name }}:</label>
                                <br />
                                <input type="text" ng-model="$ctrl.translations[language.locale].seo.title" />
                                <br />
                                <label>Opis w języku {{ language.name }}:</label>
                                <br />
                                <input type="text" ng-model="$ctrl.translations[language.locale].seo.description" />
                                <br />
                                <label>H1 w języku {{ language.name }}:</label>
                                <br />
                                <input type="text" ng-model="$ctrl.translations[language.locale].seo.h1" />
                                <br />
                                <label>Anchor w stopce {{ language.name }}:</label>
                                <br />
                                <input type="text" ng-model="$ctrl.translations[language.locale].seo.footer_anchor" />
                                <br />
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz SEO</span><i class="material-icons">save</i></button>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, languages, translations, close) {
                    'ngInject';

                    this.languages = languages;
                    this.translations = translations;
                    this.closeCallback = close;
                }

                save() {
                    this.closeCallback(this.translations);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                languages: languages,
                translations: item.translations
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                item.translations = result;
                this.saved = false;
            });
        });
    }

    schemaDescriptions(item) {
        const languages = this.languages;

        this.modalService.showModal({
            template: `<div class="modal material-shortcode-modal">
                <div>
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <div class="scrollable">
                        <div ng-repeat="language in $ctrl.languages" class="onecolumn">
                            <div class="header" collapse="collapse-seo-{{ language.locale }}">
                                <span>Opisy schema.org w języku <img ng-src="/assets/common/flags/by-locales/{{ language.locale }}.png" alt="{{ language.locale }}" /> {{ language.name }} </span>
                            </div>
                            <br class="clear">
                            <div class="content">
                                <label>Nazwa w języku {{ language.name }}:</label>
                                <br />
                                <input type="text" ng-model="$ctrl.translations[language.locale].schema_descriptions.name" />
                                <br />
                                <label>Opis w języku {{ language.name }}:</label>
                                <br />
                                <input type="text" ng-model="$ctrl.translations[language.locale].schema_descriptions.description" />
                                <br />
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz opisy schema.org</span><i class="material-icons">save</i></button>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, languages, translations, close) {
                    'ngInject';

                    this.languages = languages;
                    this.translations = translations;
                    this.closeCallback = close;
                }

                save() {
                    this.closeCallback(this.translations);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                languages: languages,
                translations: item.translations
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                item.translations = result;
                this.saved = false;
            });
        });
    }

    sizeListing(item) {
        if (item.items.length > 0) return false;

        return true;
    }

    pricesAvailable(item) {
        if (item.items.length < 1) return false;

        if (this.depthInt === 2) return true;

        if (this.depthInt === 3) return false;

        for (const child of item.items) {
            if (child.items && child.items.length > 0) return false;
        }

        return true;
    }

    prices(item) {
        let priceGroups = this.priceGroups;

        this.modalService.showModal({
            template: `<div class="modal material-prices-modal">
                <div style="overflow-y: scroll; overflow-x: hidden;">
                    <button ng-click="$ctrl.close()" class="close" style="right: 2px !important; top: 2px !important;"></button>
                    <h2>Ceny grubości: {{ $ctrl.item.admin_name }}</h2>
                    <div class="d-flex">
                        <div>
                            <label>Cena KG:</label><br />
                            <input type="number" ng-model="$ctrl.item.prices.pricePerKg" step="0.01" ng-change="$ctrl.recalculatePrices()" />
                        </div>
                        <div>
                            <label>Kurs Euro:</label><br />
                            <input type="number" ng-model="$ctrl.item.prices.euro" step="0.01" ng-change="$ctrl.recalculatePrices()" />
                        </div>
                        <div>
                            <label>Ciężar:</label><br />
                            <input type="number" ng-model="$ctrl.item.prices.wage" step="0.01" ng-change="$ctrl.recalculatePrices()" />
                        </div>
                        <div>
                            <label>Dopłata za kolor:</label><br />
                            <input type="number" ng-model="$ctrl.item.prices.color" step="0.01" ng-change="$ctrl.recalculatePrices()" />
                        </div>
                    </div>
                    <br /><br />
                    <div class="onecolumn" ng-repeat="priceGroup in $ctrl.priceGroups">
                        <div class="header" collapse>
                            <span>{{ priceGroup.name }}</span>
                        </div>
                        <br class="clear">
                        <div class="content" style="display: none;">
                            <div>
                                <table class="data" cellspacing="0" cellpadding="0">
                                    <thead>
                                        <tr>
                                            <th>m2</th>
                                            <th>1</th>
                                            <th>3</th>
                                            <th>6</th>
                                            <th>12</th>
                                            <th>25</th>
                                            <th>50</th>
                                            <th>100</th>
                                            <th>200</th>
                                            <th>201</th>
                                            <th rowspan="2">Dopłata za grubość</th>
                                            <th rowspan="2">Cena zakupu</th>
                                            <th rowspan="2">Importuj</th>
                                        </tr>
                                        <tr ng-if="$ctrl.item.priceGroups">
                                            <th>Grubość materiału</th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[0]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[1]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[2]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[3]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[4]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[5]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[6]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[7]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                            <th>
                                                <input type="number" ng-model="$ctrl.item.priceGroups[priceGroup.id].percentage[8]" step="1" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />%
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr ng-repeat="size in $ctrl.item.items" ng-if="size.childPriceGroups">
                                            <td>{{ size.name }}</td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[0] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[0] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[1] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[1] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[2] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[2] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[3] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[3] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[4] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[4] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[5] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[5] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[6] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[6] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[7] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[7] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerSize[8] | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.childWarehousePriceGroups[priceGroup.id].pricePerSize[8] | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="number" ng-model="size.childPriceGroups[priceGroup.id].ratio" step="0.01" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />
                                            </td>
                                            <td>
                                                <input type="text" value="{{ size.childPriceGroups[priceGroup.id].pricePerKg | number : 2 }}" readonly ng-if="!size.importPriceGroups[priceGroup.id]" />
                                                <input type="text" value="{{ size.purchase_price | number : 2 }}" readonly ng-if="size.importPriceGroups[priceGroup.id]" />
                                            </td>
                                            <td>
                                                <input type="checkbox" ng-model="size.importPriceGroups[priceGroup.id]" ng-true-value="true" ng-false-value="false" ng-checked="size.importPriceGroups[priceGroup.id]" style="width: auto;" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" />
                                            </td>
                                        <tr>
                                    </tbody>
                                    <tfoot>
                                        <tr ng-if="$ctrl.item.priceGroups">
                                            <td>Marża</td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[0] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[1] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[2] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[3] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[4] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[5] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[6] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[7] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].margin[8] | number : 2 }}" readonly /></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr ng-if="$ctrl.item.priceGroups">
                                            <td>Marża po rab.</td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[0] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[1] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[2] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[3] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[4] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[5] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[6] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[7] | number : 2 }}" readonly /></td>
                                            <td><input type="text" value="{{ $ctrl.item.priceGroups[priceGroup.id].discountMargin[8] | number : 2 }}" readonly /></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                                <div class="mt20">
                                    <select name="sourcePriceGroup" ng-model="$ctrl.sourcePriceGroup">
                                        <option selected="selected" ng-value="null">- Skopiuj dane z grupy cenowej -</option>
                                        <option ng-repeat="scPriceGroup in $ctrl.priceGroups" ng-value="scPriceGroup" ng-if="scPriceGroup.id !== priceGroup.id">{{ scPriceGroup.name }}</option>
                                    </select>
                                    <button type="button" class="button" ng-click="$ctrl.copyPriceGroup(priceGroup)" ng-disabled="!$ctrl.sourcePriceGroup">
                                        <span>Skopiuj dane z grupy <span ng-if="$ctrl.sourcePriceGroup">"{{ $ctrl.sourcePriceGroup.name }}" do grupy "{{ priceGroup.name }}"</span></span><i class="material-icons">content_copy</i>
                                    </button>
                                </div>
                                <div><small>Po skopiowaniu pamiętaj o zapisaniu danych</small></div>
                            </div>
                        </div>
                    </div>
                    <br /><br />
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz ceny materiału</span><i class="material-icons">save</i></button>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, item, priceGroups, close) {
                    'ngInject';

                    // old
                    const defaultPrices = {
                        euro: 4.22,
                        wage: 1.0,
                        pricePerKg: 3.0,
                        color: 1.0,
                        percentage: [155, 135, 120, 110, 100, 90, 85, 80, 75],
                        margin: [100, 85, 70, 60, 55, 50, 45, 40, 35],
                        discountMargin: [100, 85, 70, 60, 55, 50, 45, 40, 35]
                    }

                    // new
                    const defaultPriceGroups = {
                        percentage: [155, 135, 120, 110, 100, 90, 85, 80, 75],
                        margin: [100, 85, 70, 60, 55, 50, 45, 40, 35],
                        discountMargin: [100, 85, 70, 60, 55, 50, 45, 40, 35]
                    }

                    const defaultWarehousePrices = {
                        percentage: [155, 135, 120, 110, 100, 90, 85, 80, 75]
                    }

                    const defaultSizePrices = {
                        pricePerKg: 1.0,
                        ratio: 1.0,
                        pricePerSize: [0, 0, 0, 0, 0, 0, 0, 0, 0]
                    };

                    const defaultSizeWarehousePrices = {
                        pricePerKg: 1.0,
                        pricePerSize: [0, 0, 0, 0, 0, 0, 0, 0, 0]
                    }

                    // old
                    if (!item.prices) {
                        item.prices = angular.copy(defaultPrices);
                    }

                    if (!item.warehousePrices) {
                        item.warehousePrices  = angular.copy(defaultWarehousePrices);
                    }

                    for (const child of item.items) {
                        if (!child.childPrices) {
                            child.childPrices = angular.copy(defaultSizePrices);
                        }

                        if (!child.childWarehousePrices) {
                            child.childWarehousePrices = angular.copy(defaultSizeWarehousePrices);
                        }
                    }

                    // new
                    for (const priceGroup of priceGroups) {
                        if (!item.priceGroups) item.priceGroups = {};
                        if (!item.warehousePriceGroups) item.warehousePriceGroups = {};
                        if (!item.importPriceGroups) item.importPriceGroups = {};

                        if (!item.priceGroups[priceGroup.id]) {
                            const tmpDefaultPriceGroups = {
                                2: {
                                    percentage: [70, 60, 50, 45, 40, 35, 30, 20, 20],
                                    margin: [100, 85, 70, 60, 55, 50, 45, 40, 35],
                                    discountMargin: [100, 85, 70, 60, 55, 50, 45, 40, 35]
                                },
                                3: {
                                    percentage: [75, 65, 55, 50, 45, 40, 35, 30, 25],
                                    margin: [100, 85, 70, 60, 55, 50, 45, 40, 35],
                                    discountMargin: [100, 85, 70, 60, 55, 50, 45, 40, 35]
                                },
                                4: {
                                    percentage: [80, 70, 60, 55, 50, 45, 40, 35, 30],
                                    margin: [100, 85, 70, 60, 55, 50, 45, 40, 35],
                                    discountMargin: [100, 85, 70, 60, 55, 50, 45, 40, 35]
                                },
                                5: {
                                    percentage: [85, 75, 65, 60, 55, 50, 45, 40, 35],
                                    margin: [100, 85, 70, 60, 55, 50, 45, 40, 35],
                                    discountMargin: [100, 85, 70, 60, 55, 50, 45, 40, 35]
                                },
                                6: {
                                    percentage: [90, 80, 70, 65, 60, 55, 50, 45, 40],
                                    margin: [100, 85, 70, 60, 55, 50, 45, 40, 35],
                                    discountMargin: [100, 85, 70, 60, 55, 50, 45, 40, 35]
                                },
                                7: {
                                    percentage: [108, 96, 84, 78, 72, 66, 60, 54, 48],
                                    margin: [100, 85, 70, 60, 55, 50, 45, 40, 35],
                                    discountMargin: [100, 85, 70, 60, 55, 50, 45, 40, 35]
                                },
                            };

                            if (tmpDefaultPriceGroups[priceGroup.id]) {
                                item.priceGroups[priceGroup.id] = angular.copy(tmpDefaultPriceGroups[priceGroup.id]);
                            } else {
                                item.priceGroups[priceGroup.id] = angular.copy(defaultPriceGroups);
                            }
                        }

                        if (!item.warehousePriceGroups[priceGroup.id]) {
                            item.warehousePriceGroups[priceGroup.id]  = angular.copy(defaultWarehousePrices);
                        }

                        if (typeof item.importPriceGroups[priceGroup.id] == 'undefined') {
                            item.importPriceGroups[priceGroup.id] = true;
                        }

                        for (const child of item.items) {
                            if (!child.childPriceGroups) child.childPriceGroups = {};
                            if (!child.childWarehousePriceGroups) child.childWarehousePriceGroups = {};
                            if (!child.importPriceGroups) child.importPriceGroups = {};

                            if (!child.childPriceGroups[priceGroup.id]) {
                                child.childPriceGroups[priceGroup.id] = angular.copy(defaultSizePrices);
                            }

                            if (!child.childWarehousePriceGroups[priceGroup.id]) {
                                child.childWarehousePriceGroups[priceGroup.id] = angular.copy(defaultSizeWarehousePrices);
                            }

                            if (typeof child.importPriceGroups[priceGroup.id] == 'undefined') {
                                child.importPriceGroups[priceGroup.id] = true;
                            }
                        }
                    }

                    item = this.removeNonExistentPriceGroups(item, priceGroups);

                    this.item = item;
                    this.priceGroups = priceGroups;
                    this.sourcePriceGroup = null;
                    this.closeCallback = close;

                    // old
                    this.recalculatePrices();

                    // new
                    for (const priceGroup of priceGroups) {
                        this.recalculatePriceGroup(priceGroup);
                    }
                }

                removeNonExistentPriceGroups(item, priceGroups) {
                    const priceGroupIds = priceGroups.map(pg => pg.id);

                    for (const key in item.priceGroups) {
                        if (!priceGroupIds.includes(parseInt(key))) {
                            delete item.priceGroups[key];
                        }
                    }

                    for (const key in item.warehousePriceGroups) {
                        if (!priceGroupIds.includes(parseInt(key))) {
                            delete item.warehousePriceGroups[key];
                        }
                    }

                    for (const key in item.importPriceGroups) {
                        if (!priceGroupIds.includes(parseInt(key))) {
                            delete item.importPriceGroups[key];
                        }
                    }

                    for (const child of item.items) {
                        for (const key in child.childPriceGroups) {
                            if (!priceGroupIds.includes(parseInt(key))) {
                                delete child.childPriceGroups[key];
                            }
                        }

                        for (const key in child.childWarehousePriceGroups) {
                            if (!priceGroupIds.includes(parseInt(key))) {
                                delete child.childWarehousePriceGroups[key];
                            }
                        }

                        for (const key in child.importPriceGroups) {
                            if (!priceGroupIds.includes(parseInt(key))) {
                                delete child.importPriceGroups[key];
                            }
                        }
                    }

                    return item;
                }

                recalculatePrices() {
                    this.item.warehousePrices.percentage = this.item.prices.percentage;

                    for (const child of this.item.items) {
                        // pricePerKg
                        child.childPrices.pricePerKg = child.value * this.item.prices.pricePerKg * this.item.prices.wage * this.item.prices.color * child.childPrices.ratio * this.item.prices.euro;
                        child.childWarehousePrices.pricePerKg = child.purchase_price;

                        // pricePerSize
                        for (let i = 0; i < this.item.prices.percentage.length; i++) {
                            child.childPrices.pricePerSize[i] = child.childPrices.pricePerKg + (child.childPrices.pricePerKg * (this.item.prices.percentage[i] / 100));
                            child.childWarehousePrices.pricePerSize[i] = child.purchase_price + (child.purchase_price * (this.item.prices.percentage[i] / 100));
                        }
                    }

                    // margin + discountMargin
                    for (let i = 0; i < this.item.prices.percentage.length; i++) {
                        if (!this.item.items[0].import) {
                            this.item.prices.margin[i] = ((this.item.items[0].childPrices.pricePerSize[i] - this.item.items[0].childPrices.pricePerKg) / this.item.items[0].childPrices.pricePerKg) * 100;
                            this.item.prices.discountMargin[i] = (((this.item.items[0].childPrices.pricePerSize[i] * 0.85) / this.item.items[0].childPrices.pricePerKg) - 1) * 100;
                        } else {
                            this.item.prices.margin[i] = ((this.item.items[0].childWarehousePrices.pricePerSize[i] - this.item.items[0].childWarehousePrices.pricePerKg) / this.item.items[0].childWarehousePrices.pricePerKg) * 100;
                            this.item.prices.discountMargin[i] = (((this.item.items[0].childWarehousePrices.pricePerSize[i] * 0.85) / this.item.items[0].childWarehousePrices.pricePerKg) - 1) * 100;
                        }
                    }
                }

                recalculatePriceGroup(priceGroup) {
                    this.item.warehousePriceGroups[priceGroup.id].percentage = this.item.priceGroups[priceGroup.id].percentage;

                    for (const child of this.item.items) {
                        // pricePerKg
                        child.childPriceGroups[priceGroup.id].pricePerKg = child.value * this.item.prices.pricePerKg * this.item.prices.wage * this.item.prices.color * child.childPriceGroups[priceGroup.id].ratio * this.item.prices.euro;
                        child.childWarehousePriceGroups[priceGroup.id].pricePerKg = child.purchase_price;

                        // pricePerSize
                        for (let i = 0; i < this.item.priceGroups[priceGroup.id].percentage.length; i++) {
                            child.childPriceGroups[priceGroup.id].pricePerSize[i] = child.childPriceGroups[priceGroup.id].pricePerKg + (child.childPriceGroups[priceGroup.id].pricePerKg * (this.item.priceGroups[priceGroup.id].percentage[i] / 100));
                            child.childWarehousePriceGroups[priceGroup.id].pricePerSize[i] = child.purchase_price + (child.purchase_price * (this.item.priceGroups[priceGroup.id].percentage[i] / 100));
                        }
                    }

                    // margin + discountMargin
                    for (let i = 0; i < this.item.priceGroups[priceGroup.id].percentage.length; i++) {
                        if (!this.item.items[0].importPriceGroups[priceGroup.id]) {
                            this.item.priceGroups[priceGroup.id].margin[i] = ((this.item.items[0].childPriceGroups[priceGroup.id].pricePerSize[i] - this.item.items[0].childPriceGroups[priceGroup.id].pricePerKg) / this.item.items[0].childPriceGroups[priceGroup.id].pricePerKg) * 100;
                            this.item.priceGroups[priceGroup.id].discountMargin[i] = (((this.item.items[0].childPriceGroups[priceGroup.id].pricePerSize[i] * 0.85) / this.item.items[0].childPriceGroups[priceGroup.id].pricePerKg) - 1) * 100;
                        } else {
                            this.item.priceGroups[priceGroup.id].margin[i] = ((this.item.items[0].childWarehousePriceGroups[priceGroup.id].pricePerSize[i] - this.item.items[0].childWarehousePriceGroups[priceGroup.id].pricePerKg) / this.item.items[0].childWarehousePriceGroups[priceGroup.id].pricePerKg) * 100;
                            this.item.priceGroups[priceGroup.id].discountMargin[i] = (((this.item.items[0].childWarehousePriceGroups[priceGroup.id].pricePerSize[i] * 0.85) / this.item.items[0].childWarehousePriceGroups[priceGroup.id].pricePerKg) - 1) * 100;
                        }
                    }
                }

                copyPriceGroup(targetGroup) {
                    if (!this.sourcePriceGroup) {
                        return false;
                    }

                    const targetGroupId = targetGroup.id;
                    const sourceGroupId = this.sourcePriceGroup.id;
                    const sourceGroupData = this.item.priceGroups[sourceGroupId];

                    this.item.priceGroups[targetGroupId] = JSON.parse(JSON.stringify(sourceGroupData));

                    for (const size of this.item.items) {
                        if (size.childPriceGroups[sourceGroupId]) {
                            size.childPriceGroups[targetGroupId] = JSON.parse(JSON.stringify(size.childPriceGroups[sourceGroupId]));
                        }
                        if (size.childWarehousePriceGroups[sourceGroupId]) {
                            size.childWarehousePriceGroups[targetGroupId] = JSON.parse(JSON.stringify(size.childWarehousePriceGroups[sourceGroupId]));
                        }
                        size.importPriceGroups[targetGroupId] = size.importPriceGroups[sourceGroupId];
                    }

                    this.recalculatePriceGroup(targetGroup);
                    this.sourcePriceGroup = null;
                }

                save() {
                    this.closeCallback(this.item);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                item: item,
                priceGroups: priceGroups
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                this.saved = false;
            });
        });
    }

    cutPrices(item) {
        let priceGroups = this.priceGroups;

        const shops = this.shops;

        this.modalService.showModal({
            template: `<div class="modal material-cut-prices-modal">
                <div>
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <div>
                        <div class="scrollable">
                            <div class="onecolumn" id="collapse-cut-prices-cut-modes">
                                <div class="header" collapse>
                                    <span>Ceny cięcia</span>
                                </div>
                                <br class="clear">
                                <div class="content" style="display: none;">
                                    <div class="onecolumn" style="width: 100%;" ng-repeat="priceGroup in $ctrl.priceGroups">
                                        <div class="header" collapse>
                                            <span>{{ priceGroup.name }}</span>
                                        </div>
                                        <br class="clear">
                                        <div class="content" style="display: none;">
                                            <div ng-repeat="mode in $ctrl.cutModes">
                                                <div class="onecolumn" style="width: 100%;">
                                                    <div class="header" collapse="collapse-cut-prices-cut-modes-{{ mode.tag }}">
                                                        <span>{{ mode.name }}</span>
                                                    </div>
                                                    <br class="clear">
                                                    <div class="content" style="display: none;">
                                                        <label>Minimalka</label> <input type="number" ng-model="$ctrl.item.cutPriceGroups[priceGroup.id][mode.tagMin]" step="0.01" />
                                                        <hr />
                                                        <table class="data" cellspacing="0" cellpadding="0">
                                                            <thead>
                                                                <tr>
                                                                    <th>Grubość materiału</th><th>10MB</th><th>25MB</th><th>50MB</th><th>100MB</th><th>200MB</th><th>500MB</th>
                                                                </tr>
                                                            </thead>
                                                                <tr ng-repeat="size in $ctrl.item.items" ng-if="size.childCutPriceGroups[priceGroup.id]">
                                                                    <td>{{ size.name }}</td>
                                                                    <td><input type="text" value="{{ size.childCutPriceGroups[priceGroup.id][mode.tag][0] | number : 2 }}" readonly/></td>
                                                                    <td><input type="text" value="{{ size.childCutPriceGroups[priceGroup.id][mode.tag][1] | number : 2 }}" readonly/></td>
                                                                    <td><input type="text" value="{{ size.childCutPriceGroups[priceGroup.id][mode.tag][2] | number : 2 }}" readonly/></td>
                                                                    <td><input type="text" value="{{ size.childCutPriceGroups[priceGroup.id][mode.tag][3] | number : 2 }}" readonly/></td>
                                                                    <td><input type="text" value="{{ size.childCutPriceGroups[priceGroup.id][mode.tag][4] | number : 2 }}" readonly/></td>
                                                                    <td><input type="number" ng-model="size.childCutPriceGroups[priceGroup.id][mode.tag][5]" step="0.01" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" /></td>
                                                                <tr>
                                                            </tbody>
                                                            <tfoot>
                                                                <tr ng-if="$ctrl.item.cutPriceGroups[priceGroup.id]">
                                                                    <td>zł/h</td>
                                                                    <td><input type="number" ng-model="$ctrl.item.cutPriceGroups[priceGroup.id][mode.tag][0]" step="0.01" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" /></td>
                                                                    <td><input type="number" ng-model="$ctrl.item.cutPriceGroups[priceGroup.id][mode.tag][1]" step="0.01" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" /></td>
                                                                    <td><input type="number" ng-model="$ctrl.item.cutPriceGroups[priceGroup.id][mode.tag][2]" step="0.01" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" /></td>
                                                                    <td><input type="number" ng-model="$ctrl.item.cutPriceGroups[priceGroup.id][mode.tag][3]" step="0.01" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" /></td>
                                                                    <td><input type="number" ng-model="$ctrl.item.cutPriceGroups[priceGroup.id][mode.tag][4]" step="0.01" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" /></td>
                                                                    <td><input type="number" ng-model="$ctrl.item.cutPriceGroups[priceGroup.id][mode.tag][5]" step="0.01" ng-change="$ctrl.recalculatePriceGroup(priceGroup)" /></td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt20">
                                                <select name="sourcePriceGroup" ng-model="$ctrl.sourcePriceGroup">
                                                    <option selected="selected" ng-value="null">- Skopiuj dane z grupy cenowej -</option>
                                                    <option ng-repeat="scPriceGroup in $ctrl.priceGroups" ng-value="scPriceGroup" ng-if="scPriceGroup.id !== priceGroup.id">{{ scPriceGroup.name }}</option>
                                                </select>
                                                <button type="button" class="button" ng-click="$ctrl.copyPriceGroup(priceGroup)" ng-disabled="!$ctrl.sourcePriceGroup">
                                                    <span>Skopiuj dane z grupy <span ng-if="$ctrl.sourcePriceGroup">"{{ $ctrl.sourcePriceGroup.name }}" do grupy "{{ priceGroup.name }}"</span></span><i class="material-icons">content_copy</i>
                                                </button>
                                            </div>
                                            <div><small>Po skopiowaniu pamiętaj o zapisaniu danych</small></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="onecolumn" id="collapse-cut-prices-dimensions">
                                <div class="header" collapse>
                                    <span>Maksymalne wymiary formatki</span>
                                </div>
                                <br class="clear">
                                <div class="content" style="display: none;">
                                    <div ng-repeat="shop in $ctrl.shops">
                                        <br /><h3>Sklep <img ng-src="/assets/common/flags/by-locales/{{ shop.language.locale }}.png" alt="{{ shop.name }}" /> {{ shop.name }}</h3>
                                        <label>Szerokość:</label> <input type="number" ng-model="$ctrl.item.dimensions[shop.id].max_width" step="1" />
                                        <label>Wysokość:</label> <input type="number" ng-model="$ctrl.item.dimensions[shop.id].max_height" step="1" />
                                    </div>
                                </div>
                            </div>

                            <div class="onecolumn" id="collapse-cut-shapes-holes-cut-modes">
                                <div class="header" collapse>
                                    <span>Dostępność, kształty, wycięcia</span>
                                </div>
                                <br class="clear">
                                <div class="content" style="display: none;">
                                    <div ng-repeat="mode in $ctrl.cutModes">
                                        <div class="onecolumn" style="width: 100%;">
                                            <div class="header" collapse="collapse-cut-shapes-holes-cut-modes-{{ mode.tag }}">
                                                <span>{{ mode.name }}</span>
                                            </div>
                                            <br class="clear">
                                            <div class="content" style="display: none;">
                                                <div>
                                                    <label><input type="checkbox" ng-model="$ctrl.item.cutPrices[mode.tagAvailable]" ng-true-value="'1'" /> Metoda cięcia jest dostępna</label>
                                                    <hr />
                                                    <h4>Dostępne kształty główne:</h4>
                                                    <div ng-repeat="shape in $ctrl.mainShapeTypes" style="line-height: 0;">
                                                        <label ng-if="shape.name && shape.name !== ''" style="margin: 0;"><input type="checkbox" ng-model="$ctrl.item.availableMainShapes[mode.tag][shape.name]" ng-true-value="'1'" /> {{ shape.name }}</label><br />
                                                    </div>
                                                    <br />
                                                    <h4>Dostępne rodzaje wycięć:</h4>
                                                    <div ng-repeat="shape in $ctrl.holeTypes" style="line-height: 0;">
                                                        <label ng-if="shape.name && shape.name !== ''" style="margin: 0;"><input type="checkbox" ng-model="$ctrl.item.availableHoleTypes[mode.tag][shape.name]" ng-true-value="'1'" /> {{ shape.name }}</label><br />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="actions">
                            <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz ceny cięcia</span><i class="material-icons">save</i></button>
                        </div>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, priceGroups, shops, item, close) {
                    'ngInject';

                    // old
                    const defaultCutPrices = {
                        laser: [0, 0, 0, 0, 0, 0],
                        chain: [0, 0, 0, 0, 0, 0],
                        chainPolished: [0, 0, 0, 0, 0, 0],
                        frez: [0, 0, 0, 0, 0, 0],
                        laserMinimal: 30,
                        chainMinimal: 20,
                        chainPolishedMinimal: 30,
                        frezMinimal: 50,
                        laserAvailable: true,
                        chainAvailable: true,
                        chainPolishedAvailable: true,
                        frezAvailable: true,
                        maxWidth: 2050,
                        maxHeight: 3050
                    }

                    // new
                    const defaultCutPriceGroups = {
                        laser: [600, 500, 400, 300, 200, 100],
                        chain: [600, 500, 400, 300, 200, 100],
                        chainPolished: [600, 500, 400, 300, 200, 100],
                        frez: [600, 500, 400, 300, 200, 100],
                        laserMinimal: 30,
                        chainMinimal: 20,
                        chainPolishedMinimal: 30,
                        frezMinimal: 50
                    }

                    // old
                    const defaultChildCutPrices = {
                        laser: [0, 0, 0, 0, 0, 0],
                        chain: [0, 0, 0, 0, 0, 0],
                        chainPolished: [0, 0, 0, 0, 0, 0],
                        frez: [0, 0, 0, 0, 0, 0]
                    }

                    // new
                    const defaultChildCutPriceGroups = {
                        laser: [0, 0, 0, 0, 0, 1.01],
                        chain: [0, 0, 0, 0, 0, 1.01],
                        chainPolished: [0, 0, 0, 0, 0, 1.01],
                        frez: [0, 0, 0, 0, 0, 1.01]
                    }

                    this.cutModes = [
                        {
                            name: "Laser",
                            tag: "laser",
                            tagMin: "laserMinimal",
                            tagAvailable: "laserAvailable"
                        },
                        {
                            name: "Piła",
                            tag: "chain",
                            tagMin: "chainMinimal",
                            tagAvailable: "chainAvailable"
                        },
                        {
                            name: "Polerowanie",
                            tag: "chainPolished",
                            tagMin: "chainPolishedMinimal",
                            tagAvailable: "chainPolishedAvailable"
                        },
                        {
                            name: "Frez",
                            tag: "frez",
                            tagMin: "frezMinimal",
                            tagAvailable: "frezAvailable"
                        }
                    ];

                    this.mainShapeTypes = MainShapeType;
                    this.holeTypes = HoleType;

                    if (!item.availableMainShapes) {
                        item.availableMainShapes = {};

                        for (const cutMode of this.cutModes) {
                            item.availableMainShapes[cutMode.tag] = {};

                            for (const shape of MainShapeType) {
                                item.availableMainShapes[cutMode.tag][shape.name] = true;
                            }
                        }
                    }

                    if (!item.availableHoleTypes) {
                        item.availableHoleTypes = {};

                        for (const cutMode of this.cutModes) {
                            item.availableHoleTypes[cutMode.tag] = {};

                            for (const shape of HoleType) {
                                item.availableHoleTypes[cutMode.tag][shape.name] = true;
                            }
                        }
                    }

                    // old
                    if (!item.cutPrices) {
                        item.cutPrices = angular.copy(defaultCutPrices);
                    }

                    if (typeof item.cutPrices.frez == 'undefined') item.cutPrices.frez = [0, 0, 0, 0, 0, 0];

                    if (!item.cutPrices.laserMinimal) item.cutPrices.laserMinimal = 20;
                    if (!item.cutPrices.chainMinimal) item.cutPrices.chainMinimal = 20;
                    if (!item.cutPrices.chainPolishedMinimal) item.cutPrices.chainPolishedMinimal = 20;
                    if (!item.cutPrices.frezMinimal) item.cutPrices.frezMinimal = 20;

                    if (typeof item.cutPrices.laserAvailable == 'undefined') item.cutPrices.laserAvailable = true;
                    if (typeof item.cutPrices.chainAvailable == 'undefined') item.cutPrices.chainAvailable = true;
                    if (typeof item.cutPrices.chainPolishedAvailable == 'undefined') item.cutPrices.chainPolishedAvailable = true;
                    if (typeof item.cutPrices.frezAvailable == 'undefined') item.cutPrices.frezAvailable = false;

                    if (typeof item.cutPrices.maxWidth == 'undefined') item.cutPrices.maxWidth = 2050
                    if (typeof item.cutPrices.maxHeight == 'undefined') item.cutPrices.maxHeight = 3050;

                    for (const child of item.items) {
                        if (!child.childCutPrices) child.childCutPrices = angular.copy(defaultChildCutPrices);
                        if (typeof child.childCutPrices.frez == 'undefined') child.childCutPrices.frez = [0, 0, 0, 0, 0, 0];
                    }

                    // new
                    for (const priceGroup of priceGroups) {
                        if (!item.cutPriceGroups) {
                            item.cutPriceGroups = {};
                        }

                        if (!item.cutPriceGroups[priceGroup.id]) {
                            const tmpDefaultCutPriceGroups = {
                                2: {
									laser: [600, 525, 450, 405, 360, 330],
									chain: [825, 660, 578, 495, 413, 330],
									chainPolished: [436, 327, 305, 284, 262, 240],
									frez: [333, 293, 280, 267, 253, 240],
									laserMinimal: 30,
									chainMinimal: 20,
									chainPolishedMinimal: 30,
									frezMinimal: 50
								},
                                3: {
									laser: [600, 525, 450, 405, 360, 330],
									chain: [825, 660, 578, 495, 413, 330],
									chainPolished: [436, 327, 305, 284, 262, 240],
									frez: [333, 293, 280, 267, 253, 240],
									laserMinimal: 30,
									chainMinimal: 20,
									chainPolishedMinimal: 30,
									frezMinimal: 50
								},
                                4: {
									laser: [600, 525, 450, 405, 360, 330],
									chain: [825, 660, 578, 495, 413, 330],
									chainPolished: [436, 327, 305, 284, 262, 240],
									frez: [333, 293, 280, 267, 253, 240],
									laserMinimal: 30,
									chainMinimal: 20,
									chainPolishedMinimal: 30,
									frezMinimal: 50
								},
                                5: {
									laser: [600, 525, 450, 405, 360, 330],
									chain: [825, 660, 578, 495, 413, 330],
									chainPolished: [436, 327, 305, 284, 262, 240],
									frez: [333, 293, 280, 267, 253, 240],
									laserMinimal: 30,
									chainMinimal: 20,
									chainPolishedMinimal: 30,
									frezMinimal: 50
								},
                                6: {
									laser: [600, 525, 450, 405, 360, 330],
									chain: [825, 660, 578, 495, 413, 330],
									chainPolished: [436, 327, 305, 284, 262, 240],
									frez: [333, 293, 280, 267, 253, 240],
									laserMinimal: 30,
									chainMinimal: 20,
									chainPolishedMinimal: 30,
									frezMinimal: 50
								},
                                7: {
									laser: [720, 630, 540, 486, 432, 396],
									chain: [990, 792, 694, 594, 496, 396],
									chainPolished: [523, 392, 366, 341, 314, 288],
									frez: [400, 352, 336, 320, 304, 288],
									laserMinimal: 30,
									chainMinimal: 20,
									chainPolishedMinimal: 30,
									frezMinimal: 50
								}
                            };

                            if (tmpDefaultCutPriceGroups[priceGroup.id]) {
                                item.cutPriceGroups[priceGroup.id] = angular.copy(tmpDefaultCutPriceGroups[priceGroup.id]);
                            } else {
                                item.cutPriceGroups[priceGroup.id] = angular.copy(defaultCutPriceGroups);
                            }
                        }
    
                        if (typeof item.cutPriceGroups[priceGroup.id].frez == 'undefined') {
                            item.cutPriceGroups[priceGroup.id].frez = [0, 0, 0, 0, 0, 0];
                        }
    
                        if (!item.cutPriceGroups[priceGroup.id].laserMinimal) {
                            item.cutPriceGroups[priceGroup.id].laserMinimal = 30;
                        }

                        if (!item.cutPriceGroups[priceGroup.id].chainMinimal) {
                            item.cutPriceGroups[priceGroup.id].chainMinimal = 20;
                        }

                        if (!item.cutPriceGroups[priceGroup.id].chainPolishedMinimal) {
                            item.cutPriceGroups[priceGroup.id].chainPolishedMinimal = 30;
                        }

                        if (!item.cutPriceGroups[priceGroup.id].frezMinimal) {
                            item.cutPriceGroups[priceGroup.id].frezMinimal = 50;
                        }

                        for (const child of item.items) {
                            if (!child.childCutPriceGroups) {
                                child.childCutPriceGroups = {};
                            }

                            if (!child.childCutPriceGroups[priceGroup.id]) {
                                child.childCutPriceGroups[priceGroup.id] = angular.copy(defaultChildCutPriceGroups);
                            }
                        }
                    }

                    item = this.removeNonExistentPriceGroups(item, priceGroups);

                    this.priceGroups = priceGroups;
                    this.shops = shops;
                    this.item = item;
                    this.sourcePriceGroup = null;
                    this.closeCallback = close;

                    // old
                    this.recalculatePrices();

                    // new
                    for (const priceGroup of priceGroups) {
                        this.recalculatePriceGroup(priceGroup);
                    }
                }

                removeNonExistentPriceGroups(item, priceGroups) {
                    const priceGroupIds = priceGroups.map(pg => pg.id);

                    for (const key in item.cutPriceGroups) {
                        if (!priceGroupIds.includes(parseInt(key))) {
                            delete item.cutPriceGroups[key];
                        }
                    }

                    for (const child of item.items) {
                        for (const key in child.childCutPriceGroups) {
                            if (!priceGroupIds.includes(parseInt(key))) {
                                delete child.childCutPriceGroups[key];
                            }
                        }
                    }

                    return item;
                }

                recalculatePrices() {
                    for (const cutMode of this.cutModes) {
                        for (const child of this.item.items) {
                            for (let i = 4; i > -1; i--) {
                                if (this.item.cutPrices[cutMode.tag][i + 1] < 1) {
                                    child.childCutPrices[cutMode.tag][i] = 0;
                                    continue;
                                }

                                child.childCutPrices[cutMode.tag][i] = (child.childCutPrices[cutMode.tag][i + 1] / this.item.cutPrices[cutMode.tag][i + 1]) * this.item.cutPrices[cutMode.tag][i];
                            }
                        }
                    }
                }

                recalculatePriceGroup(priceGroup) {
                    for (const cutMode of this.cutModes) {
                        for (const child of this.item.items) {
                            for (let i = 4; i > -1; i--) {
                                if (this.item.cutPriceGroups[priceGroup.id][cutMode.tag][i + 1] < 1) {
                                    child.childCutPriceGroups[priceGroup.id][cutMode.tag][i] = 0;
                                    continue;
                                }

                                child.childCutPriceGroups[priceGroup.id][cutMode.tag][i] = (child.childCutPriceGroups[priceGroup.id][cutMode.tag][i + 1] / this.item.cutPriceGroups[priceGroup.id][cutMode.tag][i + 1]) * this.item.cutPriceGroups[priceGroup.id][cutMode.tag][i];
                            }
                        }
                    }
                }

                copyPriceGroup(targetGroup) {
                    if (!this.sourcePriceGroup) {
                        return false;
                    }

                    const targetGroupId = targetGroup.id;
                    const sourceGroupId = this.sourcePriceGroup.id;
                    const sourceGroupData = this.item.cutPriceGroups[sourceGroupId];

                    this.item.cutPriceGroups[targetGroupId] = JSON.parse(JSON.stringify(sourceGroupData));

                    for (const size of this.item.items) {
                        if (size.childCutPriceGroups[sourceGroupId]) {
                            size.childCutPriceGroups[targetGroupId] = JSON.parse(JSON.stringify(size.childCutPriceGroups[sourceGroupId]));
                        }
                    }

                    this.recalculatePriceGroup(targetGroup);
                    this.sourcePriceGroup = null;
                }

                save() {
                    this.closeCallback(this.item);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                priceGroups: priceGroups,
                shops: shops,
                item: item
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) return false;

                this.saved = false;
            });
        });
    }

    printTypesAvailable(item) {
        return item.items.length > 0 && (this.depthInt === 0 || this.depthInt === 1);
    }

    printTypes(item) {
        this.modalService.showModal({
            template: `<div class="modal">
                <div ng-if="!$ctrl.loading">
                    <button ng-click="$ctrl.close()" class="close"></button>
                    <strong>Dostępne tryby druku dla {{ $ctrl.itemName }}</strong>
                    <div ng-repeat="(printType, printTypeName) in $ctrl.printTypes">
                        <input type="checkbox" ng-model="$ctrl.availablePrintTypes[printType]" id="print_type_{{ printType }}">
                        <label for="print_type_{{ printType }}">{{ printTypeName }}</label>
                    </div><br/>
                    <div class="actions">
                        <button type="button" class="button" ng-click="$ctrl.save()"><span>Zapisz tryby druku dla {{ $ctrl.itemName }}</span><i class="material-icons">save</i></button>
                    </div>
                </div>
                <div ng-if="$ctrl.loading">
                    <div class="loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, printsService, availablePrintTypes, itemName, close) {
                    'ngInject';

                    this.availablePrintTypes = availablePrintTypes;
                    this.closeCallback = close;
                    this.service = printsService;
                    this.printTypes = {};
                    this.itemName = itemName;
                    this.loading = true;

                    this.service.getPrintModes().then(
                        response => {
                            this.printTypes = response;
                            this.loading = false;
                        },
                        response => {
                            alert('Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem.');
                        }
                    )
                }

                save() {
                    this.closeCallback(this.availablePrintTypes);
                }

                close() {
                    this.closeCallback(null);
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                availablePrintTypes: item.availablePrintTypes,
                itemName: item.name
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) {
                    return;
                }
                item.availablePrintTypes = result;
                this.saved = false;
            });
        });
    }

    get depthInt() {
        if (!this.depth) return 0;

        return parseInt(this.depth);
    }
}

let treeComponent = {
    bindings: {
        items: '<',
        saved: '<',
        depth: '@',
        priceGroups: '<',
        languages: '<',
        shops: '<'
    },
    template: treeHtml,
    controller: treeController
};

export default treeComponent;
